module.exports = __webpack_public_path__ + "static/media/backlight8.c0d828e0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/fotos/Backlight/backlight8.jpg
// module id = 319
// module chunks = 0